import React from 'react';
import { 
    Paper, Typography, Box, Avatar, Chip, Divider, Grid 
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { imagesURL } from '../../../apiRoutes/apiBase'; 
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export default function SubscriptionCard({ subscription, onClick }) {
    const theme = useTheme();

    const getStatusColor = (status) => {
        switch (status) {
            case 'active': return 'success';
            case 'past_due': return 'error';
            case 'pending': return 'warning';
            case 'canceled': return 'default';
            case 'trialing': return 'info';
            default: return 'default';
        }
    };

    const getStatusLabel = (status) => {
        const map = {
            active: 'Activa',
            past_due: 'Pago Pendiente',
            pending: 'Pendiente',
            canceled: 'Cancelada',
            trialing: 'Prueba Gratis'
        };
        return map[status] || status;
    };

    return (
        <Paper
            elevation={3}
            onClick={onClick} // El evento click va directo en el Paper
            sx={{ 
                borderRadius: 2, 
                mb: 2,
                p: 2, // Padding interno (Reemplaza a CardContent)
                cursor: 'pointer', // Hacemos que parezca clicable
                position: 'relative',
                overflow: 'hidden',
                
                // --- TU EFECTO DE HOVER LIMPIO ---
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border-color 0.2s',
                border: '1px solid transparent', // Prepara el borde para que no salte
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[10],
                    //borderColor: theme.palette.link.light // Opcional: un borde sutil de color
                }
            }}
        >
            {/* --- CABECERA: COMERCIO Y PRECIO --- */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box display="flex" alignItems="center">
                    <Avatar 
                        src={subscription.merchant_img ? `${imagesURL}/${subscription.merchant_img}` : ''} 
                        alt={subscription.merchant_name}
                        sx={{ width: 40, height: 40, mr: 1.5, bgcolor: theme.palette.primary.main }}
                    >
                        {subscription.merchant_name ? subscription.merchant_name[0] : 'C'}
                    </Avatar>
                    <Box>
                        <Typography variant="subtitle2" color="textSecondary" lineHeight={1}>
                            Suscripción en
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {subscription.merchant_name}
                        </Typography>
                    </Box>
                </Box>
                <Box textAlign="right">
                    <Typography variant="h6" color="primary" fontWeight="bold">
                        {subscription.price_display}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {subscription.frequency}
                    </Typography>
                </Box>
            </Box>

            <Divider sx={{ mb: 2 }} />

            {/* --- CUERPO: PLAN Y BENEFICIARIO --- */}
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body1" fontWeight="bold">
                        {subscription.plan_name}
                    </Typography>
                </Grid>
                
                <Grid item xs={12} display="flex" alignItems="center" mt={1}>
                    <PersonIcon fontSize="small" color="action" sx={{ mr: 0.5 }} />
                    <Typography variant="body2" color="textSecondary">
                        Alumno: <strong>{subscription.beneficiary_name}</strong>
                    </Typography>
                </Grid>

                <Grid item xs={12} display="flex" alignItems="center" mt={0.5}>
                    <CalendarTodayIcon fontSize="small" color="action" sx={{ mr: 0.5 }} />
                    <Typography variant="body2" color="textSecondary">
                        Próximo cobro: {subscription.next_payment_date}
                    </Typography>
                </Grid>
            </Grid>

            {/* --- FOOTER: ESTATUS --- */}
            <Box mt={2} display="flex" justifyContent="flex-end">
                <Chip 
                    label={getStatusLabel(subscription.status)} 
                    color={getStatusColor(subscription.status)} 
                    size="small" 
                    variant={subscription.status === 'active' ? 'outlined' : 'filled'}
                />
            </Box>
        </Paper>
    );
}